<template>
  <div class="container-fluid">
    <div class="panel panel-info">

      <!-- <div style="text-align: left; margin: 10px" class="p-3 mb-2">
        <h5>Medical Certificate
          <b-button class="float-right" variant="danger" @click="handleBack"
            >Back</b-button
          >
        </h5>
        <hr />
      </div> -->
      <div style="text-align: left" >
        <b>Medical Certificate :</b>
        <b-button class="float-right"  variant="danger" @click="handleBack"><b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill>Back</b-button>
      </div>
      <hr />
      <div class="panel-body">
        
          <div class="md-4">
            <b-card
              img-src="https://picsum.photos/400/400/?image=10"
              img-alt="Card image"
              img-left
              class="mb-3"
              style="height: 140px"
            >
              <b-card-text class="mycard">
                <table>
                  <tr>
                    <td width="45%" style="text-align: left">Tag No</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">22</td>
                  </tr>
                  <tr>
                    <td width="45%" style="text-align: left">Animal Type</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">Cow</td>
                  </tr>
                  <tr>
                    <td width="45%" style="text-align: left">Owner Name</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">Rajesh sharma</td>
                  </tr>
                  <tr>
                    <td width="45%" style="text-align: left">Village/City</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">solapur</td>
                  </tr>
                </table>
              </b-card-text>
              <b-card-text class="mycard"> </b-card-text>
            </b-card>

            <!-- <router-link
                style="color: white"
                :to="{ name: 'medical' }"
                >medical</router-link
              > -->
          </div>
          <div class="form-group">
            <label for="exampleFormControlTextarea1"
              ><b>Observations:</b></label
            >
            <textarea
              class="form-control"
              id="exampleFormControlTextarea1"
              rows="3"
            ></textarea>
          </div>

              <a
                href="#"
                style="float: right; margin-left: 10px"
                class="btn btn-secondary"
                v-on:click="reset_details()"
                >Reset</a
              >&nbsp;
              <a href="#" style="float: right" class="btn btn-secondary"
                >
                <router-link
                        style="color:white;"
                        :to="{ name: 'Appointment'}"
                      >Submit</router-link></a
                
              >
              <!-- <b-button style="float: left" variant="danger" @click="handleBack">Back</b-button> -->
              

          <!-- <b-card no-body class="overflow-hidden" style="max-width: 540px">
            <b-row no-gutters> </b-row>
          </b-card> -->
        </div>
      </div>
   
  </div>
</template>

<script>
import * as _ from "lodash";

//import ApplicationFilter from "../components/ApplicationFilter.vue";
//import MarksEntry from "../components/MarksEntry.vue";
//alert(1);
export default {
  methods: {
    reset_details() {
      this.Observations = "";
    },
    handleBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
table {
  font-family: arial, sans-serif;

  width: 100%;
}

td,
th {
  border: 0px solid #dddddd;
  text-align: left;
  padding: 2px;
}
.mycard {
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>
